var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCartAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.23719 1.28845C1.84423 1.15746 1.41949 1.36983 1.28851 1.76279C1.15752 2.15575 1.36989 2.58049 1.76285 2.71147L3.79538 3.38898C4.13831 3.50329 4.39369 3.79259 4.46458 4.14705L6.74303 15.5393C7.00011 16.8247 8.12876 17.75 9.43963 17.75H18C18.4142 17.75 18.75 17.4142 18.75 17C18.75 16.5858 18.4142 16.25 18 16.25H9.43963C8.84378 16.25 8.33076 15.8294 8.2139 15.2451L7.91487 13.75H18.4385C19.7004 13.75 20.8003 12.8912 21.1064 11.667L22.417 6.4244C22.6931 5.31989 21.8577 4.24996 20.7192 4.24996H6.01487L5.93546 3.85287C5.759 2.97058 5.12331 2.25049 4.26972 1.96596L2.23719 1.28845Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 20.5C11 21.3284 10.3284 22 9.5 22C8.67157 22 8 21.3284 8 20.5C8 19.6716 8.67157 19 9.5 19C10.3284 19 11 19.6716 11 20.5Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 22C17.3284 22 18 21.3284 18 20.5C18 19.6716 17.3284 19 16.5 19C15.6716 19 15 19.6716 15 20.5C15 21.3284 15.6716 22 16.5 22Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCartAlt);
export default __webpack_public_path__ + "static/media/cart-alt.3e57d2dc32eaa3e912b8a221b08cc7bc.svg";
export { ForwardRef as ReactComponent };